import React, { useEffect, useState } from "react";
import clsx from "clsx";
import {
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableContainer,
  Typography,
  useTheme,
  Chip,
  TablePagination,
  Button,
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { connect } from "react-redux";
import { actions } from "../../../../redux/actions/alert";
import { AuthService } from "../../../../services/auth.service";
import styles from "../../../../styles/global-styles";
import StyleTableRow from "../../../../styles/styleTableRow";
import StyledTableCell from "../../../../styles/tableCell";
import StatelessTableHeadProduct from "../../../stateless/headTables/StatelessTableHeadProduct";
import NumberFormat from "react-number-format";
import { changeRowsPerPage } from "../../../../_utils/utils";
import MovileInfoModal from "../../modals/MovileInfoModal";
import {
  getMovilesByFilters,
  movilesAvailableInSite,
  addAvailabilityToProductsInSite,
} from "../utils.inventory";
import MovileHeader from "./headers/MovileHeader";
import BackDrop from "../../../shared/backdrop/Backdrop";
import ReactExport from "react-export-excel";
import { SiteService } from "../../../../services/site.service";
import { ProductService } from "../../../../services/product.service";
import { green } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
  },
  row: styles.rowHover,
  chip: styles.chip,
  subtitle: styles.subtitle,
  lowExistence: styles.lowExistence,
  mediumExistence: styles.mediumExistence,
  highExistence: styles.highExistence,
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
  buttonSuccess: {
    width: 150,
    backgroundColor: green[500],
    marginRight: 50,
    color: "#ffffff",
    "&:hover": {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

const MovileInventoryBySite = ({
  addAlert,
  detailAlert,
  history: { push },
}) => {
  const classes = useStyles();
  const theme = useTheme();

  //excel variables
  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  const [movilesArray, setmovilesArray] = useState([]);
  const [availablesInSite, setAvailablesInSite] = useState({});
  const [countProductsInSite, setCountProductsInSite] = useState(false);
  const [availablesInSiteExcel, setAvailablesInSiteExcel] = useState([]);
  const [movileByImei, setMovileByImei] = useState({});
  const [productsAvailable, setProductsAvailable] = useState(false);
  const [site, setSite] = useState({});
  /** Pagination */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const buttonClassname = clsx({
    [classes.buttonSuccess]: availablesInSiteExcel.length > 0,
  });

  useEffect(() => {
    setProductsAvailable(false);
    (async () => {
      try {
        const { siteId } = AuthService.currentUserValue;
        const queryParams = { siteId, page, limit: rowsPerPage };
        console.log("queryParams in BODY", queryParams);
        const { data } = await SiteService.getSiteById(siteId);
        setSite(data[0]);

        const result = await ProductService.getProductMovilesWithAvailability({
          siteId,
          productSold: 0,
          inDistribution: 0,
        });
        const {
          data: { movileArray, movilesAvailable },
        } = result;
        const totalArrayWithAvailability = addAvailabilityToProductsInSite(
          movileArray,
          movilesAvailable
        );
        console.log("totalMovilesWithAvailability", totalArrayWithAvailability);
        setAvailablesInSiteExcel(totalArrayWithAvailability);

        const { moviles, count } = await getMovilesByFilters(queryParams);
        getMovilesAvailable(moviles);
        setmovilesArray({ moviles, count });
      } catch (error) {
        console.log(error);
        addAlert({ showAlert: true });
        detailAlert({
          severity: "error",
          message: error.msgs || "Error al recuperar productos",
        });
      }
    })();
  }, [page, rowsPerPage]);

  useEffect(() => {
    if (countProductsInSite) {
      const productsWithAvailability = addAvailabilityToProductsInSite(
        movilesArray.moviles,
        availablesInSite
      );
      console.log("productsWithAvailability CHECK", productsWithAvailability);
      setmovilesArray({
        ...movilesArray,
        moviles: productsWithAvailability,
      });
      setProductsAvailable(true);
      setCountProductsInSite(false);
    }
  }, [countProductsInSite]);

  const getMovilesAvailable = async (movilesArray) => {
    try {
      const { availableInSite } = await movilesAvailableInSite(movilesArray);
      setAvailablesInSite(availableInSite);
      setCountProductsInSite(true);
    } catch (error) {
      console.log("error", error);
      addAlert({ showAlert: true });
      detailAlert({
        severity: "error",
        message: error.msg
          ? error.msg
          : "Error al obtener la disponibilidad de productos",
      });
    }
  };

  const handleMovileFilteredByImei = (result, isSuccess) => {
    if (isSuccess) {
      setMovileByImei(result);
    } else {
      addAlert({ showAlert: true });
      detailAlert({
        severity: result.mssgError ? "warning" : "error",
        message: result.mssgError ? result.mssgError : result.msgs,
      });
    }
  };

  const handleCloseModal = () => {
    setMovileByImei({});
  };

  const goToUrl = (url, product) => {
    const { brand, model, barCode, siteId } = product;
    return push(url, { brand, model, barCode, siteId, productTypeId: 1 });
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  return (
    <>
      <div style={{ display: "inline-flex", marginBottom: 20 }}>
        <MovileHeader
          title="Inventario móviles"
          movilesFiltered={handleMovileFilteredByImei}
          movilesInSite
          movileByImei={movileByImei}
        />

        <ExcelFile
          element={
            <div className={classes.wrapper}>
              <Button
                className={buttonClassname}
                disabled={!availablesInSiteExcel.length}
              >
                Exportar a excel
              </Button>
              {availablesInSiteExcel.length === 0 && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}
            </div>
          }
          filename={`Sucursal ${site.name}`}
        >
          <ExcelSheet
            data={availablesInSiteExcel}
            name={`Sucursal ${site.name}`}
          >
            <ExcelColumn label="Marca" value={(col) => col.movile.brand} />
            <ExcelColumn label="Modelo" value={(col) => col.movile.model} />
            <ExcelColumn label="Color" value={(col) => col.movile.color} />
            <ExcelColumn
              label="Código de barras"
              value={(col) => col.movile.barCode}
            />
            <ExcelColumn label="Lote" value={(col) => col.movile.lote} />
            <ExcelColumn label="Precio" value={(col) => col.movile.price} />
            <ExcelColumn
              label="Descuento"
              value={(col) => col.movile.discount}
            />
            <ExcelColumn
              label="Disponibilidad"
              value={(col) => col.availablesInSite}
            />
          </ExcelSheet>
        </ExcelFile>
      </div>
      <Grid style={{ marginTop: theme.spacing(3) }}>
        <TableContainer>
          {movilesArray.moviles?.length > 0 ? (
            <Table className={classes.table} aria-label="customized table">
              <StatelessTableHeadProduct isMovile={true} singleSite />
              <TableBody>
                {movilesArray.moviles.map((row, i) => (
                  <StyleTableRow
                    key={i}
                    className={classes.row}
                    onClick={() =>
                      goToUrl(
                        "/dashboard/inventario/sucursal/detalle-producto",
                        row
                      )
                    }
                  >
                    <StyledTableCell align="center">
                      {row.brand}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row.model}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row.capacity}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Chip label={row.color || "-"} className={classes.chip} />
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row.barCode}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <NumberFormat
                        value={row.price}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row.discount || "N/A"}
                    </StyledTableCell>
                    <StyledTableCell align="center">{row.lote}</StyledTableCell>
                    <StyledTableCell align="center">
                      <Chip
                        label={row.availablesInSite}
                        className={
                          row.availablesInSite <= 3
                            ? classes.lowExistence
                            : row.availablesInSite <= 7
                            ? classes.mediumExistence
                            : classes.highExistence
                        }
                      />
                    </StyledTableCell>
                  </StyleTableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <Typography
              variant="h6"
              component="h4"
              style={{ marginTop: 50 }}
              className={classes.subtitle}
            >
              No hay equipos móviles asignados a esta sucursal
            </Typography>
          )}
        </TableContainer>
        {movilesArray.count > 0 && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={movilesArray.count}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={(event) => {
              const { rowsPerPage, page } = changeRowsPerPage(event);
              setRowsPerPage(rowsPerPage);
              setPage(page);
            }}
          />
        )}
      </Grid>
      {!productsAvailable && (
        <BackDrop
          style={{
            zIndex: 1,
            color: "#1C2668",
          }}
          isOpen={!productsAvailable}
        />
      )}

      {Object.values(movileByImei).length > 0 && (
        <MovileInfoModal
          searchBySite
          open={Object.values(movileByImei).length > 0}
          detailProduct={movileByImei}
          productId={movileByImei.id}
          onClose={handleCloseModal}
        />
      )}
    </>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(MovileInventoryBySite);
